<template>
    <div class="horizontal-stack">
        <slot />
    </div>
</template>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;

.horizontal-stack {
    @include Pathfinder.HorizontalStack;
}
</style>
